import { useState, useEffect } from 'react'
import { useAnimation as Animation } from 'framer-motion'
import { useInView } from 'react-intersection-observer'

interface UseTitleAnimationProps {
    initialSpriteIdTitle?: number
}

export const useAnimation = ({
    initialSpriteIdTitle = 0,
}: UseTitleAnimationProps = {}) => {
    const [spriteId, setSpriteId] = useState(initialSpriteIdTitle)
    const [active, setActive] = useState(false)
    const [steps, setSteps] = useState(1)
    const control = Animation()
    const [ref, inView] = useInView()

    useEffect(() => {
        const timeOut = setTimeout(() => {
            setSteps(2)
            setActive((old) => !old)
        }, 2000)

        return () => {
            clearTimeout(timeOut)
        }
    }, [active])

    useEffect(() => {
        if (inView) {
            control.start('visible')
        } else {
            control.start('hidden')
        }
    }, [control, inView])

    useEffect(() => {
        if (spriteId === 1) return
        const spiteStart = setTimeout(() => {
            setSpriteId(1)
        }, 0)

        return () => clearTimeout(spiteStart)
    }, [spriteId])

    return {
        spriteId,
        setSpriteId,
        active,
        steps,
        control,
        ref,
    }
}
